module.exports = __webpack_public_path__ + "assets/img/pjs_0.eac17bd0.png";